import { Route } from '@angular/router';

import { PaymentComponent } from './payment.component';

export const PaymentRoutes: Route[] = [
    {
      path: 'payment/:id',
      component: PaymentComponent
    }
];



// WEBPACK FOOTER //
// /home/ubuntu/MembriPay/src/app/components/payment/payment.routes.ts